import {GetBusinessPartnerInfoService} from "../Infrastructure/BusinessPartner.service";

export default async function GetBusinessPartnerInfoLogic(id) {
  return GetBusinessPartnerInfoService(id);
}